<template>
  <div id='plugin' v-if='pluginShow'>
      <div class='pluginlogoBox'>
          <div class='pluginlogoImg'>
            <img src="../assets/logo1.png" alt="橘袋|每日一袋"   >
          </div>
          <div class='pluginlogoTxt'>
              <div>NUTRIPACKS</div>
              <div>橘袋</div>
          </div>

        </div>
      <div class='pluginContent'>
          <div class='pluginTitle'>NUTRIPACKS来自美国纽约，面向企业和个人提供定制膳食补充剂。我们愿凭借15年以上研发智慧，用科学和科技帮助你成为更好的自己，追寻你所崇尚的生活价值。</div>
          <div class='pluginQrImg'>
              <img src="../assets/qr.png" alt="橘袋微信公众号">
          </div>
      </div> 
        
  </div>
</template>

<script>
  

    
export default {
  name: 'plugin',
  props: {

  },
  data:function(){
    return{
     pluginShow:false
    }
  },
  mounted:function() {
  
  var docEl = document.body.clientWidth  
      
          if(docEl>=1200){
            this.pluginShow = true
          }
  },
  methods: {
    
  }
}
</script>  

<style>
#plugin{
  position: fixed;
  right:1.6rem;
  top:50%;
  transform: translate(0, -50%); 
  
}
.pluginlogoBox{
  width:2.63rem;
  height:0.97rem;
  margin-bottom: 0.28rem;
  display: flex;

}
.pluginlogoImg{
  width:0.97rem;
  height:0.97rem;
}
.pluginlogoImg img{
  width:0.97rem;
  height:0.97rem;
}
.pluginlogoTxt{
  font-size:0.22rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:0.26rem;
  padding:0.14rem 0.22rem  0;
  text-align: left;
}
.pluginContent{
   width:2.63rem;
  height:5.37rem;
  background:rgba(255,255,255,1);
  border-radius:0.1rem;
  border:1px solid rgba(200,208,216,0.36);
  padding: 0.28rem 0.15rem;
  box-sizing: border-box;
}
.pluginTitle{
  font-size:0.17rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:0.28rem;
  text-align:justify;
  padding-bottom: 0.24rem;
  border-bottom:1px dashed rgba(204, 204, 204, 1);
  margin-bottom: 0.18rem;
}
.pluginQrImg{
  width:2.52rem;
}
.pluginQrImg img{
  width:2.52rem;
  position: relative;
  left:-0.1rem;
}
</style>